import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
import Const from '@/components/shared/helpers/Const.js';

const state = {
  AUEObjetives: [],
  AUECitySelected: [],
  AUESelected: null
};

const getters = {
  [types.ALL_AUEOBJETIVES]: state => {
    return state.AUEObjetives;
  },
  [types.AUEOBJETIVE_CIUDAD]: state => {
    return state.AUECitySelected;
  },
  [types.AUE_SELECTED]: state => {
    return state.AUESelected;
  }
};

const mutations = {
  [types.MUTATE_ALL_AUEOBJETIVES]: (state, payload) => {
    state.AUEObjetives = payload;
  },
  [types.MUTATE_AUEOBJETIVE_CIUDAD]: (state, payload) => {
    state.AUECitySelected = payload;
  },
  [types.MUTATE_AUE_SELECTED]: (state, payload) => {
    state.AUESelected = payload;
  }
};

const actions = {
  [types.ACTION_GET_ALL_AUEOBJETIVES]: ({ commit }) => {
    let request = { controller: `/Objetivo/${Const.ID_AUE}` };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_AUEOBJETIVES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_AUEOBJETIVE_CIUDAD]: ({ commit, getters }) => {
    let idMunicipio = getters['NGUD/idMunicipio'];
    let queryParam = idMunicipio ? `?IdMunicipio=${idMunicipio}` : '';
    let request = { controller: `/Objetivo/${Const.ID_AUE}/VistaGeneral${queryParam}` };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_AUEOBJETIVE_CIUDAD, response.data.objetivos);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_AUEOBJETIVE_CIUDAD]: ({ commit, getters }, payload) => {
    let ciudadId = getters['NGUD/ciudadData'].id;
    let parseData = {
      objetivos: payload.data
    };

    let request = {
      controller: `/CiudadIndice/${ciudadId}/${Const.ID_AUE}`,
      filter: {},
      body: parseData
    };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postSuit', request)
        .then(response => {
          // commit(types.MUTATE_AUEOBJETIVE_CIUDAD, response.data.objetivos);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ACCIONES_OBJETIVO_ESPECIFICO]: ({ commit, getters }, payload) => {
    let ciudadId = getters['NGUD/ciudadData'].id;
    let request = { controller: `/CiudadIndicadoresAUE/Ciudad/${ciudadId}/ObjetivoEspecifico/${payload.idObjetivo}/Acciones` };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ACCION]: ({ commit, getters }, payload) => {
    let request = { controller: `/Accion/${payload.idAccion}/Ciudad/${payload.idCiudad}` };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
